module.exports = __webpack_public_path__ + "media/images/OCAP_Logo-ac83d6aa224b0273ff5006510c34482b.png";